import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from '../../components'
import { modalOpen, modalClose } from '../../layout/redux/layoutActions'
import './video.scss'

/**
 * Componente de Vídeo Tutorial
 * Props:
 *  - videoName: "video1" | "video2" | ... | "video25"
 */
export default function Video({ videoName = 'video1', cy }) {
  const dispatch = useDispatch()
  const { sistema, statusModal } = useSelector(state => state.layoutState)

  // usa o mesmo NLS do diretório do componente (links + textos)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const videoUrl = nls?.[videoName] || null
  const modalName = `video-tutorial-${videoName}`

  const open = statusModal === modalName
  const onOpen = () => dispatch(modalOpen(modalName))
  const onClose = () => dispatch(modalClose())

  return (
    <div className="video-tutorial-wrapper">
      {/* Botão: ícone + texto, com tooltip via title */}
            <button
        data-cy={cy}
        type="button"
        className="video-tutorial"
        title={nls.videoTutorialTooltip}
        aria-label={nls.videoTutorialLabel}
        onClick={onOpen}
      >
        {/* Ícone play em círculo (SVG inline, sem libs externas) */}
        <svg
          className="video-tutorial__icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm-2 6.5 7 3.5-7 3.5V8.5z"
          />
        </svg>
        <span>{nls.videoTutorialLabel}</span>
      </button>

      {/* Modal padrão do seu app */}
      <Modal
        name={modalName}
        title={nls.videoTutorialLabel}
        size="large"
        open={open}
        close={onClose}
        closeText={nls.btnFechar || 'Fechar'}
      >
        <div className="video-tutorial__container">
          {videoUrl ? (
            <iframe
              className="video-tutorial__iframe"
              src={toEmbedUrl(videoUrl)}
              title="Video tutorial"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="video-tutorial__fallback">
              {nls.videoIndisponivel || 'Vídeo indisponível.'}
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

function toEmbedUrl(url) {
  try {
    const u = new URL(url)
    const host = u.hostname.replace('www.', '')

    // Helper p/ montar query string
    const withParams = (base, params) => {
      const q = new URLSearchParams(params)
      return `${base}?${q.toString()}`
    }

    // Extrai ID do YouTube (útil também para loop/playlist)
    const getYouTubeId = (u, host) => {
      if (host === 'youtu.be') return u.pathname.slice(1)
      if (host === 'youtube.com') return u.searchParams.get('v')
      return null
    }

    if (host === 'youtu.be' || host === 'youtube.com') {
      const id = getYouTubeId(u, host)
      const base = `https://www.youtube.com/embed/${id}`
      return withParams(base, {
        rel: '0',
        modestbranding: '1',
        iv_load_policy: '3',
        playsinline: '1',
        // enablejsapi: '1', // ative se for usar a opção B (fechar ao terminar)
      })
    }

    if (host === 'vimeo.com') {
      const id = u.pathname.split('/').filter(Boolean)[0]
      const base = `https://player.vimeo.com/video/${id}`
      return withParams(base, {
        // parâmetros “limpos” no Vimeo
        title: '0',
        byline: '0',
        portrait: '0'
      })
    }

    return url
  } catch {
    return url
  }
}


//Quando termina o vídeo, mostra ícones de vídeos fora do canal...então abandonamos

function toEmbedUrlOLD(url) {
  try {
    const u = new URL(url)
    const host = u.hostname.replace('www.', '')

    // youtu.be/<id>
    if (host === 'youtu.be') {
      const id = u.pathname.slice(1)
      return id ? `https://www.youtube.com/embed/${id}` : url
    }
    // youtube.com/watch?v=<id>
    if (host === 'youtube.com') {
      const id = u.searchParams.get('v')
      return id ? `https://www.youtube.com/embed/${id}` : url
    }
    // vimeo.com/<id>
    if (host === 'vimeo.com') {
      const id = u.pathname.split('/').filter(Boolean)[0]
      return id ? `https://player.vimeo.com/video/${id}` : url
    }
    return url
  } catch {
    return url
  }
}
